import {
  Callout,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function ReadyToStart() {
  return (
    <div className="pt-6 px-5 py-8">
      <Callout
        className="container-xl rounded-2xl"
        heading="Ready to start practicing like a pro?"
        theme="light"
      >
        <p className="max-w-prose text-neutral-500">
          Join thousands of developers honing their skills, creating incredible
          portfolios, and gaining hands-on experience using a professional
          workflow.
        </p>

        <LinkWithButtonStyles href="/pro#plans">
          Unlock Pro now
        </LinkWithButtonStyles>
      </Callout>
    </div>
  );
}
